import { Container, Link } from "./styles";

export function SocialIcons({ links }) {
  return (
    <Container>
      {links.map(({ id, name, url }) => (
        <Link key={id} href={url}>
          {name}
        </Link>
      ))}
    </Container>
  );
}